// extracted by mini-css-extract-plugin
export default {"vote":"UserVote_vote__JsU+O","vote-btns":"UserVote_vote-btns__OHfV5","score":"UserVote_score__CO+OH"};